const menuItems = [
  {
    name: 'Home',
    page: '/',
  },
  {
    name: 'About',
    page: '/about',
  },
  {
    name: 'Speakers',
    page: '/speakers',
  },
  {
    name: 'Schedule',
    page: '/schedule/day-1',
  },
  {
    name: 'Workshops',
    page: '/workshops',
  },
  {
    name: 'Conduct',
    page: '/conduct',
  },
]

export default menuItems
